import { render, staticRenderFns } from "./ProfileCompletionWidget.vue?vue&type=template&id=03f17670"
import script from "./ProfileCompletionWidget.vue?vue&type=script&lang=js"
export * from "./ProfileCompletionWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports